import React, { useState, useEffect, useRef } from 'react';
import InputText from '../ReusableComponents/InputText';
import DropDown from '../ReusableComponents/DropDown';
import { mainTable } from '../css/Common';
import Buttons from '../components/Buttons';
import AddScreenTitle from '../components/AddScreenTitle';
import MainLayout from '../components/MainLayout';
import GridPage from '../components/GridPage';
import { enquiryHeaders, BookingDetailsHeaders, enquiryLostHeaders } from '../components/HeaderAttribute';
import MainPopup from '../popup-containers/MainPopup';
import PopUpScreenTitle from '../components/PopUpScreenTitle';
import Enquirypopup from '../popup-containers/Enquirypopup';
import PopUpButtons from '../components/PopUpButtons';
import { useNavigate } from 'react-router-dom';
import RadioGroup from '../ReusableComponents/RadioButton';
import OnLostPopUp from '../popup-containers/onLostPopUp';
import ConfirmBookingPopUp from '../popup-containers/ConfirmBookingPopUp';
import OnHoldPopUp from '../popup-containers/onHoldPopUp';
import MultiSelect from '../ReusableComponents/MultiSelect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Checkbox from '../ReusableComponents/Checkbox';
import villaImage from '../image/villa1.jpg';
import Image1 from '../image/Image1.jpeg';
import { BindAPI, IUDAPI, BindPostAPI } from '../services/APIConnection'
import ErrorPopup from '../ReusableComponents/ErrorPopup';
import toast from 'react-hot-toast';
import { faL } from '@fortawesome/free-solid-svg-icons';



const EnquiryHold = () => {

    const today = new Date()//.toISOString()
    const [formData, setFormData] = useState({
        fname: '',
        lname: '',
        number: '',

        enquirydate: today,
        enquiryid: "ENQ-2025-000001",
        enquirytype: '',

        fromdate: '',
        todate: '',
        state: '',
        country: '',

        pincode: '',
        city: '',
        streetdoorno: '',
        area: '',
        idproof: '',
        idvalue: '',
        noofdays: '',
        sourcetype: '',
        source: '',
        referralcontact: '',
        roomtype: [],
        basictariff: '',
        specialtariff: '',
        amountpaid: ''


    });

    useEffect(() => {
        const { fromdate, todate } = formData;

        if (fromdate && todate) {
            const from = new Date(fromdate);
            const to = new Date(todate);
            const diffTime = to - from;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            setFormData((prev) => ({
                ...prev,
                noofdays: diffDays >= 0 ? diffDays.toString() : '',
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                noofdays: '',
            }));
        }
    }, [formData.fromdate, formData.todate]);


    const [lost, setLost] = useState(false);
    const [onBook, setOnBook] = useState(false);
    const [hold, setHold] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [errors, setErrors] = useState({
        fname: '',
        lname: '',
        number: '',

        villaname: '',
        villatype: '',
        enquirydate: '',
        enquiryid: '',
        enquirytype: '',
        fromdate: '',
        todate: '',
        amount: '',

    });


    const [popUpData, setPopUpData] = useState([])


    const [villanamedropdown, setvilladropdown] = useState(
        [
            { value: '1', label: 'Villa 1-Sunset View' },
            { value: '2', label: 'Villa 2-Beach view ' },
            { value: '3', label: 'Villa 3-Maharaja' }
        ])

    const [villatypedropdown, setvillatypedropdown] = useState(
        [
            { value: '1', label: '1BHK-AC' },
            { value: '2', label: '2BHK-AC ' },
            { value: '3', label: '2BHK-Non-AC' }
        ])
    const [iddropdown, setiddropdown] = useState(
        [
            { value: '1', label: 'Aadhar Card' },
            { value: '2', label: 'Voter-ID' },
            { value: '3', label: 'Passport Number' },
            { value: '4', label: 'Driving License' },
        ])

    const [referralsource, setreferralsource] = useState([])
    const [roomtype, setroomtype] = useState([])
    const [enquirytypedropdown, setenquirydropdown] = useState(
        [
            // { value: '1', label: 'Individual' },
            // { value: '2', label: 'Corporate' },
        ])

    const [lostreasondropdown, setlostreasondropdown] = useState(
        [
            { value: '1', label: 'Price' },
            { value: '2', label: 'Room not available' },
            { value: '3', label: 'facility not as per need' },


        ])

    const [countrydropdown, setCountrydropdown] = useState(
        [
            // { value: '1', label: 'United States' },
            // { value: '2', label: 'India' },
            // { value: '3', label: 'UK' },
            // { value: '4', label: 'Sri Lanka' },
            // { value: '5', label: 'Japan' }
        ])

    const [statedropdown, setStatedropdown] = useState(
        [

            // { value: '1', label: 'Tamil Nadu' },
            // { value: '2', label: 'Karnataka' },
            // { value: '3', label: 'Kerala' },
            // { value: '4', label: 'Andhra Pradesh' }
        ])
    const [districtdropdown, setdistrictdropdown] = useState(
        [
            // { value: '1', label: 'Madurai' },
            // { value: '2', label: 'Dindigul' },
            // { value: '3', label: 'Tiruchirapalli' }
        ])

    const [adultdropdown, setadultdropdown] = useState(
        [
            { value: '1', label: '1' },
            { value: '2', label: '2' },
            { value: '3', label: '3' },
            { value: '4', label: '4' },
            { value: '5', label: '5' },
        ])
    const [childrendropdown, setchildrendropdown] = useState(
        [
            { value: '1', label: '1' },
            { value: '2', label: '2' },
            { value: '3', label: '3' },
            { value: '4', label: '4' },
            { value: '5', label: '5' },
        ])



    // useEffect(() => {
    //   const today = new Date().toISOString().split('T')[0];
    //   setFormData((prevData) => ({ ...prevData, enquirydate: today }));
    // }, []);

    const handleInputChangeForm = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));

        // Optionally clear errors on change
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: ''
        }));
    };

    // const fieldLabels = {
    //   fname: 'First Name',
    //   lname: 'Last Name',
    //   //villaname: '',
    //    // villatype: '',
    //     enquirydate: 'Enquiry Date',
    //     enquiryid: '',
    //     enquirytype: 'Enquiry Type',
    //     fromdate: 'Booking From',
    //     todate: 'Booking To',
    //     number:'Mobile Number'

    // };

    const fieldLabels = {
        fname: { label: 'First Name', type: 'text' },
        lname: { label: 'Last Name', type: 'text' },
        fromdate: { label: 'Booking From', type: 'date' },
        todate: { label: 'Booking To', type: 'date' },
        enquirytype: { label: 'Enquiry Type', type: 'select-one' },
        enquirydate: { label: 'Enquiry Date', type: 'date' },
        number: { label: "Mobile Number", type: 'text' }
        // Add more fields here as needed
    };

    const typelabel = [
        { name: 'fname', label: 'First Name', type: 'text' },
        { name: 'lname', label: 'Last Name', type: 'text' },
        { name: 'fromdate', label: 'Booking From', type: 'date' },
        { name: 'todate', label: 'Booking To', type: 'date' },
    ];


    const handleBlur = (e) => {
        const { name, value } = e.target;
        const field = fieldLabels[name];
        if (!field) return;

        const label = field.label;
        const type = field.type;

        const message = value.trim() === ''
            ? (type === 'select-one' ? `Select ${label}` : `Enter ${label}`)
            : '';

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: message
        }));
    };


    const [tableData, setTableData] = useState([
        {
            //   villaname: '',
            //   propertysize:'',
            //   maximumocuupancy:'',
            //   noofbedrooms:'',
            //   villatype: '',
            //   balconystatus:'',
            //   roomtariff:'',
            //   isroomselected:''
            //room:1


        }
    ]);

    const enquiryChilddata = [{
        mstRoomTypeId: tableData.MstRoomtypeId,
        mstRoomId: '',
        noOfAvailableRooms: tableData.AvailableRooms,
        basicTariff: tableData.Tariff,
        specialTariff: tableData.specialtariff,
        noOfRequiredRooms: tableData.numberofrooms,
        noOfAdults: tableData.numberfoadults,
        noOfChildren: tableData.numberofchildren,
        amount: tableData.amount,
        mstEnquiryStatusId: '',
        mstHoldReasonId: '',
        holdFollowUpDate: '',
        mstHoldReasonNotes: '',
        mstLostReasonId: '',
        mstLostReasonNotes: '',

    }

    ]

    const createdBy = sessionStorage.getItem("createdBy");
    const onSave = async (rowIndex, flag) => {

           

        const isValid = validateForm('save'); // Validate only save fields
        if (flag == 1 || flag == 2) {
            if (!isValid) {
                setIsOpen(true);
                //setIsLoading(false);
                setSubmitBtnDisabled(false);
            }
            if (isValid) {
                setIsOpen(false);
                //setIsLoading(true);

                const enquiryChilddata =
                {
                    txnEnquiryChildId: 0, // or existing ID if updating
                    mstRoomTypeId: 1,// tableData.MstRoomtypeId,
                    mstRoomId: 2, // Replace with valid ID or keep 0/null if not applicable
                    noOfAvailableRooms: 4,// tableData.AvailableRooms,//parseInt(tableData.AvailableRooms),
                    basicTariff: 500,//tableData.Tariff,//parseFloat(tableData.Tariff),
                    specialTariff: 100,//tableData.specialtariff,//parseFloat(tableData.specialtariff),
                    noOfRequiredRooms: 1,// tableData.numberofrooms,// parseInt(tableData.numberofrooms),
                    noOfAdults: 2,// tableData.numberfoadults,//parseInt(tableData.numberfoadults),
                    noOfChildren: 1,//tableData.numberofchildren,// parseInt(tableData.numberofchildren),
                    amount: tableData.amount,// parseFloat(tableData.amount),
                    mstEnquiryStatusId: 1,
                    mstHoldReasonId: 0,
                    holdFollowUpDate: "2025-07-12T10:31:31.862Z",//new Date().toLocaleDateString(), // or user input
                    mstHoldReasonNotes: "Some note",
                    mstLostReasonId: 0,
                    lostReasonNotes: "Another note"
                }


                const data = {
                    txnEnquiryId: 0,
                    enquiryNo: "ENQ",
                    enquiryDate: formData.enquirydate,
                    mstEnquiryTypeId: formData.enquirytype || 0,
                    bookingFrom: formData.fromdate,
                    bookingTo: formData.todate,
                    noOfDays: formData.noofdays || 0,
                    //done
                    firstName: formData.fname || "",
                    lastName: formData.lname || "",
                    mobileNumber: formData.number || "",
                    //done
                    mstCountryId: formData.country || 0,
                    mstStateId: formData.state || 0,
                    city: formData.city || "",
                    streetDoorNo: formData.streetdoorno || "",
                    area: formData.area || "",
                    pincode: formData.pincode || "",
                    mstSourceTypeId: formData.sourcetype || 0,
                    contactNumber: formData.referralcontact || "",
                    mstIdProofId: formData.idproof || 0,

                    idNumber: formData.idvalue || "",
                    source: formData.source || "",


                    //belowdone
                    amount: formData.amountpaid || 0,
                    createdBy: createdBy,
                    flag: flag,
                    enquiryChild: JSON.stringify(tableData)
                    //enquiryChild: '[{ \"mstRoomTypeId\": 1, \"mstRoomId\": 2, \"noOfAvailableRooms\": 2, \"basicTariff\": 2500, \"specialTariff\": 500, \"noOfRequiredRooms\": 1, \"noOfAdults\": 1, \"noOfChildren\": 2, \"amount\": 3500, \"mstEnquiryStatusId\": 1, \"mstHoldReasonId\": 0, \"holdFollowUpDate\": \"2025-07-11\", \"mstHoldReasonNotes\": \"Some note\", \"mstLostReasonId\": 0, \"lostReasonNotes\": \"Another note\" }]'
                };



                const response = await IUDAPI(data, "Enquiry/IUDEnquiry");
                console.log(data)
                console.log("formData:", formData);



                if (flag == 1) {                                              //if flag ==1 , add
                    if (response.data.Table[0].Result === 'S') {
                        toast.success("Enquiry  Inserted Seccessfully", {
                            duration: 3000,
                            position: "top-center",
                        });
                        setTimeout(cancel, 3000);
                    } else {
                        toast.error("Enquiry insert Failed", {
                            duration: 3000,
                            position: "top-center",
                        });
                        setTimeout(cancel, 3000);
                    }
                } else if (flag == 2) {                     //if flag ==2 , update

                    if (response.data.Table[0].Result === "M") {
                        toast.success("Enquiry modified successfully! 👍", {
                            duration: 3000,
                            position: "top-center",
                        });
                        setTimeout(cancel, 3000);
                    } else {
                        toast.error("Enquiry modification failed 👎", {
                            duration: 3000,
                            position: "top-center",
                        });
                        setTimeout(cancel, 3000);
                    }
                }
            } else { setSubmitBtnDisabled(false); }
        } else {
            const data = {                     // data to be send to api, if add/update

                txnEnquiryId: TxnEnquiryId ? TxnEnquiryId : 0,
                enquiryDate: formData.enquirydate,
                mstEnquiryTypeId: formData.enquirytype,
                bookingFrom: formData.fromdate,
                bookingTo: formData.todate,
                noOfDays: formData.noofdays,
                firstName: formData.fname,
                LastName: formData.lname,
                mobileNumber: formData.number,
                mstCountryId: formData.country,
                mstStateId: formData.state,
                city: formData.city,
                streetDoorNo: formData.street,
                area: formData.area,
                pincode: formData.pincode,
                mstSourceTypeId: formData.sourcetype,
                source: formData.source,
                contactNumber: formData.contactNumber,
                mstIdProofId: formData.idproof,
                idNumber: formData.idvalue,
                amount: formData.amount,
                createdBy: createdBy,
                flag: flag,
                enquiryChild: JSON.stringify(tableData)
            };

            const response = await IUDAPI([data], "Enquiry/IUDEnquiry");

            if (flag == 3) {                                            //if flag ==3 , delete
                if (response.data.Table[0].Result === 'D') {
                    toast.success("Cancellation Reason Data Deleted Successfully", {
                        duration: 3000,
                        position: "top-center",
                    });
                    setTimeout(cancel, 3000);
                } else {
                    toast.error("Failed to delete Cancellation Reason", {
                        duration: 3000,
                        position: "top-center",
                    });
                }
                setTimeout(cancel, 3000);



            }
        }


    };



    const navigate = useNavigate();

    const validateForm = (action) => {
        let formValid = true;
        const newErrors = {};
        let fieldsToValidate = [];

        if (action === 'save') {
            fieldsToValidate = ['fname', 'number', 'fromdate', 'todate'];
        }

        fieldsToValidate.forEach((key) => {
            const value = formData[key] || '';
            const field = fieldLabels[key];

            if (!field) return; // skip unknown fields

            const { label, type } = field;

            if (value.trim() === '') {
                const message = type === 'select-one' ? `Select ${label}` : `Enter ${label}`;
                newErrors[key] = message;
                formValid = false;
            }





        });
        setErrors(newErrors);
        return formValid

    };
    const [bindEnquiryData, setBindEnquiryData] = useState([

    ]);

    const [bindBookingData, setBindBookingData] = useState([

        { EnquiryNo: "ENQ-2025-000001", rooms: "Deluxe-A2,B2,Independant-A2,A6,A10,B2, Suite-A2", BookingNo: "BKG-2025-000001", GuestName: "Jenifer Jency Jaya Thipayergu", MobileNumber: "9876742466", BookFrom: " 09-07-2025", BookTo: "12-07-2025" },
        { EnquiryNo: "ENQ-2025-000002", rooms: "Deluxe-A1,B1,Independant-A2,A6,A10,B2, Suite-A2", BookingNo: "BKG-2025-000002", GuestName: "Nermal Lincy Marybbjjbbyy", MobileNumber: "9866434323", BookFrom: " 10-08-2025", BookTo: "20-08-2025" },
        { EnquiryNo: "ENQ-2025-000003", rooms: "Deluxe-A3,B2,Independant-A2,A6,A10,B2, Suite-A2", BookingNo: "BKG-2025-000003", GuestName: "Haritharan Praphafghfjbgjhrhygr", MobileNumber: "8650909860", BookFrom: " 11-09-2025", BookTo: "21-09-2025" },
        { EnquiryNo: "ENQ-2025-000004", rooms: "Deluxe-A4,B1,Independant-A2,A6,A10,B2, Suite-A2", BookingNo: "BKG-2025-000004", GuestName: "Arokiya Antony Saminathan", MobileNumber: "5646757860", BookFrom: " 15-10-2025", BookTo: "19-10-2025" },
        { EnquiryNo: "ENQ-2025-000005", rooms: "Deluxe-A2,B2,Independant-A2,A6,A10,B2, Suite-A2", BookingNo: "BKG-2025-000005", GuestName: "Antony Mariya Dosshjnnyyjbvtbbbb", MobileNumber: "7667445006", BookFrom: " 10-11-2025", BookTo: "14-11-2025" },
        { EnquiryNo: "ENQ-2025-000006", rooms: "Deluxe-A1,B2,Independant-A2,A6,A10,B2, Suite-A2", BookingNo: "BKG-2025-000006", GuestName: "Helan henryjyfbjjtvhthttbjyj", MobileNumber: "8663437890", BookFrom: " 11-11-2025", BookTo: "21-11-2025" },
    ]);

    const [visibleAdd, setVisibleAdd] = useState(false);
    const [visibleTable, setVisibleTable] = useState(true);
    const [addScreenTitle, setAddScreenTitle] = useState(false);
    const [updateScreenTitle, setUpdateScreenTitle] = useState(false);



    //booking confirm

    const [popUpBookOpen, setpopUpBookOpen] = useState();
    const [popUpLostOpen, setpopUpLostOpen] = useState();
    const [popUpHoldOpen, setpopUpHoldOpen] = useState();


    const showAdd = () => {
        setVisibleAdd(true);
        setVisibleTable(false);
        setAddScreenTitle(true);
        setUpdateScreenTitle(false);
        BindEnquiryrData();

        setFormData({
            fname: '',
            lname: '',
            number: '',
            villaname: '',
            enquirydate: new Date(),
            enquiryid: '',
            enquirytype: '',
            villatype: '',
            fromdate: '',
            todate: '',
            villaselect: [],
            amount: '',
            lostreason: '',
        });

    }
    const cancel = () => {
        setVisibleAdd(false);
        setVisibleTable(true);
        setAddScreenTitle(false);
        setUpdateScreenTitle(false);
        setpopUpOpen(false);
        setpopUpBookOpen(false);
        setConfirmRecord('');
        setLostRecord('');
        setHoldRecord('');
        setpopUpHoldOpen(false);
        setpopUpLostOpen(false);
        BindEnquiryrData();
        setErrors({
            fname: '',
            lname: '',
            number: '',
            email: '',
            pincode: '',
            city: '',
            street: '',
            door: '',
            country: '',
            state: '',
            district: '',
            villaname: '',
            villatype: '',
            enquirydate: '',
            enquiryid: '',
            enquirytype: '',
            fromdate: '',
            todate: '',
            adults: '',
            children: '',
            idproof: '',
            idvalue: '',
            amount: '',
            lostreason: ''
        })

    }


    const [popUpOpen, setpopUpOpen] = useState(false);
    const [viewDetails, setViewDetails] = useState(false);
    const [deleteDetails, setDeleteDetails] = useState(false);
    const [blockDetails, setBlockDetails] = useState(false);
    const [unBlockDetails, setUnBlockDetails] = useState(false);
    const [rowIndex, setRowIndex] = useState(null);
    const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);

    const handleSubmit = () => {


    };

    const handleEdit = (rowIndex) => {
        setRowIndex(rowIndex);
        setVisibleAdd(true);
        setVisibleTable(false);
        setAddScreenTitle(false);
        setUpdateScreenTitle(true);
        setFormData({
            ...formData,

            fromdate: bindEnquiryData[rowIndex].FromFieldDate,
            todate: bindEnquiryData[rowIndex].ToFieldDate,

            villatype: bindEnquiryData[rowIndex].VillaTypeId,
            enquirydate: bindEnquiryData[rowIndex].EnquiryDateField,
            villaname: bindEnquiryData[rowIndex].VillaNameId,

            idproof: bindEnquiryData[rowIndex].IdTypeId,
            idvalue: bindEnquiryData[rowIndex].idvalue,


            enquiryid: bindEnquiryData[rowIndex].EnquiryId,
            enquirydate: bindEnquiryData[rowIndex].EnquiryDate,
            enquirytype: bindEnquiryData[rowIndex].MstEnquiryTypeId,
            fname: bindEnquiryData[rowIndex].FirstName,
            lname: bindEnquiryData[rowIndex].LastName,
            number: bindEnquiryData[rowIndex].MobileNumber,
            villaname: '',
            enquirydate: '',

            villatype: '',
            fromdate: bindEnquiryData[rowIndex].BookingFrom,
            todate: bindEnquiryData[rowIndex].BookingTo,
            state: bindEnquiryData[rowIndex].MstStateId,
            country: bindEnquiryData[rowIndex].MstCountryId,
            //district:'',
            pincode: bindEnquiryData[rowIndex].Pincode,
            city: bindEnquiryData[rowIndex].City,
            street: bindEnquiryData[rowIndex].StreetName,
            //door: '',
            idproof: bindEnquiryData[rowIndex].MstIdProofId,
            idvalue: bindEnquiryData[rowIndex].IdNumber,
            noofdays: '',
            sourcetype: bindEnquiryData[rowIndex].MstReferralSourceId,
            source: bindEnquiryData[rowIndex].ReferralPersonName,
            sourcecontact: bindEnquiryData[rowIndex].ReferralContactNumber

        })

    };
    const [confirm, setConfirmRecord] = useState('');
    //const [confirm1, setConfirmRecord1] = useState("");

    const onConfirmBooking = (rowIndex, flag) => {

        if (flag === 1) {

            console.log("val:", rowIndex)
            setRowIndex(rowIndex);
            setpopUpBookOpen(true);
            console.log("fname:", formData.fname);


            onSave()

            const namedata = {                     // data to be send to api, if add/update


                fname: formData.fname,
                lname: formData.lname,
                number: formData.number,
                fromdate: formData.fromdate,
                todate: formData.todate,
                enquiryid: formData.enquiryid,
                enquirydate: formData.enquirydate,
                enquirytype: formData.enquirytype,
                city: formData.city,
                streetdoorno: formData.streetDoorNo,
                area: formData.area,
                pincode: formData.pincode,
                source: formData.source,
                referralcontact: formData.referralcontact,
                idnumber: formData.idnumber


            };
            console.log(namedata)
            setConfirmRecord(namedata);
            //setConfirmRecord1( formData.number);
        } else {
            setpopUpBookOpen(true);

            const namedatabind = {                     // data to be send to api, if add/update
                fname: bindEnquiryData[rowIndex].GuestName,
                lname: bindEnquiryData[rowIndex].GuestName1,
                number: bindEnquiryData[rowIndex].MobileNumber,
                fromdate: bindEnquiryData[rowIndex].BookingFrom,
                todate: bindEnquiryData[rowIndex].BookingTo,
                enquiryid: bindEnquiryData[rowIndex].EnquiryId,
            };

            console.log(namedatabind)
            setConfirmRecord(namedatabind);

        }


    }

    const [holdrecord, setHoldRecord] = useState('');
    const onHoldEnquiry = (rowIndex, flag) => {



        if (flag === 1) {
            console.log("val:", rowIndex)
            setRowIndex(rowIndex);
            setpopUpHoldOpen(true);
            onSave()

            const holdData = {
                fname: formData.fname,
                lname: formData.lname,
                number: formData.number,
                fromdate: formData.fromdate,
                todate: formData.todate,
                enquiryid: formData.enquiryid,
                enquirydate: formData.enquirydate,


            }
            setHoldRecord(holdData);

        } else {
            setpopUpHoldOpen(true);
            const holdDatapop = {
                fname: bindEnquiryData[rowIndex].GuestName,
                lname: bindEnquiryData[rowIndex].GuestName,
                number: bindEnquiryData[rowIndex].GuestMobile,
                fromdate: bindEnquiryData[rowIndex].FromFieldDate,
                todate: bindEnquiryData[rowIndex].ToFieldDate,
                enquiryid: bindEnquiryData[rowIndex].EnquiryId,
                enquirydate: bindEnquiryData[rowIndex].EnquiryDateField
            }

            setHoldRecord(holdDatapop);
        }


    }

    const [lostRecord, setLostRecord] = useState('')
    const onLostEnquiry = (rowIndex, flag) => {

        if (flag === 1) {
            console.log("val:", rowIndex)
            setRowIndex(rowIndex);
            setpopUpLostOpen(true);
            onSave()

            const lostData = {
                fname: formData.fname,
                lname: formData.lname,
                number: formData.number,
                fromdate: formData.fromdate,
                todate: formData.todate,
                enquiryid: formData.enquiryid,
                number: formData.number,

            }
            setLostRecord(lostData);

        } else {
            setpopUpLostOpen(true);
            const lostDataPop = {
                fname: bindEnquiryData[rowIndex].GuestName,
                lname: bindEnquiryData[rowIndex].GuestName,
                number: bindEnquiryData[rowIndex].Guest,
                fromdate: bindEnquiryData[rowIndex].FromFieldDate,
                todate: bindEnquiryData[rowIndex].ToFieldDate,
                enquiryid: bindEnquiryData[rowIndex].EnquiryId,
                number: bindEnquiryData[rowIndex].GuestMobile,
            }
            setLostRecord(lostDataPop);
        }


    }

    const [TxnEnquiryId, setTxnEnquiryId] = useState([])

    const handleState = (rowIndex, flag) => {

        setRowIndex(rowIndex);

        setpopUpOpen(true);


        if (flag === 1) {
            setViewDetails(true);
            setDeleteDetails(false);
            setBlockDetails(false);
            setUnBlockDetails(false);
        } else if (flag === 3) {
            setViewDetails(false);
            setDeleteDetails(true);
            setBlockDetails(false);
            setUnBlockDetails(false);
        } else if (flag === 4) {
            setViewDetails(false);
            setDeleteDetails(false);
            setBlockDetails(true);
            setUnBlockDetails(false);
        } else if (flag === 5) {
            setViewDetails(false);
            setDeleteDetails(false);
            setBlockDetails(false);
            setUnBlockDetails(true);
        }

        setSelectedRecord(bindEnquiryData[rowIndex]);

        //  const rowData = bindEnquiryData[rowIndex];
        // setTxnEnquiryId( bindEnquiryData[rowIndex].TxnEnquiryId);
        // setPopUpData(rowData);

    };
    const [selectedRecord, setSelectedRecord] = useState({});

    const handleOptions = (value) => {

        if (value == 1) {
            onSave();
            setpopUpBookOpen(true)
            setOnBook(true);
            setHold(false);
            setLost(false);
        } else if (value == 2) {
            onSave();
            setpopUpHoldOpen(true)
            setOnBook(false);
            setHold(true);
            setLost(false);

        } else {
            onSave();
            setpopUpLostOpen(true)
            setOnBook(false);
            setHold(false);
            setLost(true);
        }
    }


    const [tableErrors, setTableErrors] = useState([
        {


        }
    ]);
    const handleAddRow = () => {
        if (tableData.length > 3) return;

        const newRow = {
            basictariff: ''
        };

        setTableData(prev => [...prev, newRow]);
    };

    const handleDeleteRow = (index) => {
        setTableData(prev => {
            const updated = prev.filter((_, i) => i !== index);
            return updated.length ? updated : [{
                villaname: '',
                villatype: '',

            }];
        });
    };



    const handleInputChange = (event, index) => {
        const { name, value } = event.target;
        const updatedFields = [...tableData];
        updatedFields[index][name] = value;
        setTableData(updatedFields);

    };

    const [selVillaType, setSelVillaType] = useState(
        [

            { value: '1', label: '1BHK-AC' },
            { value: '2', label: '2BHK-AC ' },
            { value: '3', label: '2BHK-Non-AC' }
        ]
    )

    useEffect(() => {
        const total = tableData.reduce(
            (sum, row) => sum + (Number(row.amount) || 0),
            0
        );

        setFormData((prev) => ({
            ...prev,
            amountpaid: total,
        }));
    }, [tableData]);






    useEffect(() => {
        BindGetEnquiryValues();
    }, []);

    const BindGetEnquiryValues = async () => {
           

        const response = await BindAPI("Enquiry/BindGetEnquiryValues")
        console.log("enquirydropdown:", response);
        if (response && response.data) {

            const enquiryTypeId = response.data.Table1.map((item) => ({
                value: item.MstEnquiryTypeId,
                label: item.EnquiryType,
            }));

            setenquirydropdown(enquiryTypeId)


            const countryId = response.data.Table2.map((item) => ({
                value: item.MstCountryId,
                label: item.CountryName_en,
            }));

            setCountrydropdown(countryId)

            const stateId = response.data.Table3.map((item) => ({
                value: item.MstStateId,
                label: item.StateName_en,
            }));

            setStatedropdown(stateId)

            const districtId = response.data.Table4.map((item) => ({
                value: item.MstDistrictId,
                label: item.DistrictName,
            }));

            setdistrictdropdown(districtId)

            const idProofId = response.data.Table5.map((item) => ({
                value: item.MstIdProofId,
                label: item.IdProof,
            }));

            setiddropdown(idProofId)

            const referralsourceid = response.data.Table6.map((item) => ({
                value: item.MstReferralSourceId,
                label: item.ReferralSource,
            }));
            setreferralsource(referralsourceid)

            const RoomTypeid = response.data.Table7.map((item) => ({
                value: item.MstRoomtypeId,
                label: item.RoomType,
            }));
            //setTableData(RoomTypeid)
            setroomtype(RoomTypeid)
            //setTableData(RoomTypeid.length)
        } else {

            setBindEnquiryData([]);
        }
    };


    // const [noofrooms,setnoofrooms]= useState([
    //   {room:1}
    // ])

    const [roomDetailsByRow, setRoomDetailsByRow] = useState({});
    ////Bind post start
    const villaselectchange = async (selectedRoomTypeId, rowIndex) => {
           
        console.log("roomdetails called with:", selectedRoomTypeId, rowIndex);

        const updatedTableData = [...tableData];

        if (!updatedTableData[rowIndex]) {
            console.error("Invalid row index", rowIndex);
            return;
        }

        updatedTableData[rowIndex].RoomTypeId = selectedRoomTypeId;
        setTableData(updatedTableData);

        const { fromdate, todate } = formData;

        if (!fromdate || !todate) {
            alert("Please select both From Date and To Date.");
            return;
        }

        if (new Date(fromdate) > new Date(todate)) {
            alert("From Date cannot be after To Date.");
            return;
        }

        const formattedFromDate = new Date(fromdate).toISOString();
        const formattedToDate = new Date(todate).toISOString();

        try {
            const data = {
                mstRoomTypeId: selectedRoomTypeId,
                fromDate: formattedFromDate,
                toDate: formattedToDate
            };

            const roomresponse = await BindPostAPI(data, "Enquiry/BindGetRoomDetails");
            console.log('room', roomresponse)

            if (roomresponse?.data?.Table?.length > 0) {
                const apiRow = roomresponse.data.Table[0];

                //  Merge only API data into the current row
                updatedTableData[rowIndex] = {
                    ...updatedTableData[rowIndex],
                    ...apiRow,
                };

                setTableData([...updatedTableData]);
            } else {
                console.warn("No room data returned");
            }
            console.log('tabledata', tableData)



        } catch (error) {
            console.error("Error fetching available villas in date range:", error);
        }
    };


    useEffect(() => {
        BindEnquiryrData();
    }, []);

    const BindEnquiryrData = async () => {

        const response = await BindAPI("Enquiry/BindEnquiry")
        console.log("API Response:", response);
        if (response && response.data) {
            setBindEnquiryData(response.data.Table)
        } else {
            setBindEnquiryData([]);
        }
    };



    const handleInputChangeTable = (e, index) => {
        // 
        const { name, value } = e.target;
        const updated = [...tableData];

        updated[index][name] = value;

        // Parse all needed values
        const tariff = Number(updated[index]["Tariff"]) || 0;
        const specialTariff = Number(updated[index]["specialtariff"]) || 0;
        const numberOfRooms = Number(updated[index]["numberofrooms"]) || 0;
        //const noofAdults= Number (updated[index]['noofadults']) || 0;

        // Example calculation (adjust as needed)
        updated[index]["amount"] = (tariff + specialTariff) * numberOfRooms;

        setTableData(updated);
        console.log(tableData)
    };



    const [selectedRooms, setSelectedRooms] = useState([]);

    const handleCheckboxChange = (e, room) => {
        const isChecked = e.target.checked;

        if (isChecked) {
            // Add to selected list
            setSelectedRooms((prev) => [...prev, room.RoomId]);


        } else {
            // Remove from selected list
            setSelectedRooms((prev) => prev.filter(id => id !== room.RoomId));
        }
    };


    return (


        <MainLayout pageName={"3"}>

            {visibleTable && (<GridPage
                title={"Enquiry Hold"}
                header={enquiryLostHeaders}
                records={bindEnquiryData}
                showAdd={showAdd}addView={true}
                handleAction={handleState}
                handleEdit={handleEdit}
                onConfirmBooking={onConfirmBooking}
                onLostEnquiry={onLostEnquiry}
                onHoldEnquiry={onHoldEnquiry} />)}

             
           
            {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}

            <MainPopup
                popUpOpen={popUpOpen}
                setpopUpOpen={setpopUpOpen}
                Open={handleState}
            >
                <div>
                    <PopUpScreenTitle
                        title="Enquiry Hold"
                        setpopUpOpen={setpopUpOpen}
                        viewDetails={viewDetails}
                        deleteDetails={deleteDetails}
                        blockDetails={blockDetails}
                        unBlockDetails={unBlockDetails}

                    />
                    <Enquirypopup data={selectedRecord} data1={popUpData} />
                </div>
                <PopUpButtons
                    deleteDetails={deleteDetails}
                    blockDetails={blockDetails}
                    unBlockDetails={unBlockDetails}
                    rowIndex={rowIndex}
                    handleSubmit={handleSubmit}
                    cancel={cancel}
                    disabledBtn={submitBtnDisabled ? true : false}
                />
            </MainPopup>



            <MainPopup
                popUpOpen={popUpBookOpen}
                setpopUpOpen={setpopUpBookOpen}
                Open={onConfirmBooking}
            >
                <div>
                    <PopUpScreenTitle
                        title="Booking Confirmation"
                        setpopUpOpen={setpopUpBookOpen}
                        hederDetails={setpopUpBookOpen}
                    />
                    <ConfirmBookingPopUp data={confirm} //data1={confirm1}
                    />

                </div>
                <PopUpButtons
                    submitDetails={AddScreenTitle}
                    rowIndex={rowIndex}
                    handleSubmit={handleSubmit}
                    cancel={cancel}
                    disabledBtn={submitBtnDisabled ? true : false}
                />
            </MainPopup>


            <MainPopup
                popUpOpen={popUpLostOpen}
                setpopUpOpen={setpopUpLostOpen}
                Open={onLostEnquiry}
            >
                <div>
                    <PopUpScreenTitle
                        title="Enquiry Lost"
                        setpopUpOpen={setpopUpLostOpen}
                        headerDetails={true}
                    />
                    <OnLostPopUp data={lostRecord}   //  to import lost enquiry popup component
                    />

                </div>
                <PopUpButtons

                    rowIndex={rowIndex}
                    handleSubmit={handleSubmit}
                    cancel={cancel}
                    disabledBtn={submitBtnDisabled ? true : false}
                />
            </MainPopup>


            <MainPopup
                popUpOpen={popUpHoldOpen}
                setpopUpOpen={setpopUpHoldOpen}
                Open={onHoldEnquiry}
            >
                <div>
                    <PopUpScreenTitle
                        title="Enquiry Hold"
                        setpopUpOpen={setpopUpHoldOpen}
                        headerDetails={true}
                    />
                    <OnHoldPopUp data={holdrecord}   //  to import Hold enquiry popup component
                    />

                </div>
                <PopUpButtons

                    rowIndex={rowIndex}
                    handleSubmit={handleSubmit}
                    cancel={cancel}
                    disabledBtn={submitBtnDisabled ? true : false}
                />
            </MainPopup>


        </MainLayout>
    );
};
export default EnquiryHold;

